export const roleNameValidation = {
  required: 'A name for the role must be provided',
  maxLength: { value: 50, message: 'Role name cannot be longer than 50 characters' },
};

export const roleDescriptionValidation = {
  maxLength: { value: 255, message: 'Description cannot be longer than 255 characters' },
};
